import { LoadingButton } from "@mui/lab";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProductVariantThunk,
  getVariantsForProductThunk,
  productVariantSelector,
} from "store/reducers/product/productVariantSlice";

const ProductVariantList = ({ product_id, onEdit }) => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    dispatch(getVariantsForProductThunk(product_id));
  }, [product_id]);

  const variants = useSelector(productVariantSelector.selectAll).filter(
    (item) => item.product === product_id
  );

  // useEffect(() => {
  //   console.log("Variants", variants);
  // }, [variants]);

  const removeVariant = (id) => {
    dispatch(deleteProductVariantThunk(id));
  };
  const { loading } = useSelector((state) => state.productVariant);
  return (
    <Box>
      {variants.length > 0 && (
        <>
          <Box
            component={Typography}
            variant="h4"
            sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
          >
            Product variants
          </Box>
          <Grid container>
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <Box
                sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
                padding={1}
              >
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          {isSmallScreen ? "Price" : "Product price"}
                        </TableCell>
                        <TableCell align="right">
                          {isSmallScreen ? "Expiry date" : "Expiry date"}
                        </TableCell>

                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {variants.map((variant) => (
                        <TableRow
                          key={variant.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            ₹ {variant.price}
                          </TableCell>
                          <TableCell align="right">
                            {variant.expiry_date}
                          </TableCell>

                          <TableCell align="right">
                            <LoadingButton
                              variant="outlined"
                              color="primary"
                              onClick={() => onEdit(variant)}
                            >
                              Edit
                            </LoadingButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default ProductVariantList;
